import React, { useEffect, useState } from 'react';
import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input.jsx';
import {
  MultiplePaymentsTable,
  NextQuotasTable,
} from '../../common/Tables/Tables.jsx';
import {
  multiplePaymentsTableHeader,
  nextQuotaTableHeader,
} from '../../../assets/helpers/tables.js';
import {
  filterById,
  returnIGTF,
  NaNtoNumber,
} from '../../../assets/helpers/funciones.js';
import { stripeService } from '../../../services/stripeService';
import authService from '../../../services/authService';
import {
  StripeModal,
  NewPaymentModal,
  CashBackComponent,
} from '../../views/Landing/LandingComponents/LandingModals.jsx';
import {
  paymentMethodsLimit,
  paymentTypeOptions,
  paymentType as paymentTypeOption,
  paymentMethods,
} from '../../../assets/helpers/options.js';
import { notify } from '../../../assets/helpers/toast';

import './Login.scss';
import {
  casheaQuotaTime,
  secondQuotaTime,
} from '../../../assets/helpers/variables.js';

export const RenewPayment = props => {
  const {
    fileUploaded,
    setFileUploaded,
    validateButtonName,
    selectUniquePayment,
    paymemtMethodOptions,
    handleReferenceChange,
    acceptPayment,
    cancelPayment,
    selectedMembership,
    selectedMethod,
    removeImage,
    successfulStripe,
    stripeModal,
    handleStipeModal,
    dollarRate,
    setPaymentType,
    options,
    cancelRenovation,
    register,
    setValue,
    errors,
    watch,
    control,
    payment,
    setPayment,
    isLoading,
    setIsloading,
  } = props;

  const [paymentTypeVar, setPaymentTypeVar] = useState([]);
  const [clientSecret, setClientSecret] = useState('');
  const [popupWindow, setPopupWindow] = useState(null);

  const nextQuotaTable = {
    header: nextQuotaTableHeader,
    watch,
    register,
    errors,
    options: {
      secondQuotaTime: secondQuotaTime,
      casheaQuotaTime: casheaQuotaTime,
    },
    label: true,
  };

  const validatePaymentOptions = () => {
    let array = [...paymentTypeOptions];

    array = array.filter(
      a =>
        ![
          paymentTypeOption?.PENDING,
          paymentTypeOption?.COURTESY,
          paymentTypeOption?.FINANCIADO,
        ].includes(a?._id)
    );

    setPaymentTypeVar(array);
  };

  const handleAmountChange = index => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    let acumulatedAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (i !== index + 1) {
        acumulatedAmount = acumulatedAmount + parseFloat(watch(`amount${i}`));
      }
    }
    const nextAmount = parseFloat(watch('billAmount') - acumulatedAmount);

    if (nextAmount > 0) {
      setValue(`amount${index + 1}`, nextAmount.toFixed(2));
      setValue(
        `amountBsS${index + 1}`,
        (watch(`amount${index + 1}`) * dollarRate).toFixed(2)
      );
      calculateIGTF(index + 1);
    }

    // Calculate IGTF
    setValue(
      `amountBsS${index}`,
      NaNtoNumber(parseFloat(watch(`amount${index}`)) * dollarRate).toFixed(2)
    );
    calculateIGTF(index);
    calculateIGTFTotal();
  };

  const handleIGTFChange = index => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));
    if (index < paymentMethodsQuantity) {
      let acumulatedIGTF = 0;
      // alculate next amount
      for (let i = 0; i < paymentMethodsQuantity; i++) {
        if (i !== index + 1) {
          acumulatedIGTF = acumulatedIGTF + parseFloat(watch(`IGTF${i}`));
        }
      }
      const nextIGTF = parseFloat(watch('totalIGTF') - acumulatedIGTF);

      if (nextIGTF > 0) {
        setValue(`IGTF${index + 1}`, nextIGTF.toFixed(2));
      }

      // Calculate final amount with IGTF in $ and BS
      for (let j = 0; j < paymentMethodsQuantity; j++) {
        setValue(
          `finalAmount${j}`,
          (
            parseFloat(watch(`amount${j}`)) + parseFloat(watch(`IGTF${j}`))
          ).toFixed(2)
        );
        setValue(
          `finalAmountBsS${j}`,
          (parseFloat(watch(`finalAmount${j}`)) * dollarRate).toFixed(2)
        );
      }
    }
  };

  const openNewStripeModal = (amount, paymentNumber, igtf) => {
    let data = {
      amount: amount,
      membership: selectedMembership?._id,
      paymentType: watch('paymentType'),
      igtf: igtf,
    };

    stripeService
      .paymentIntent(data)
      .then(response => {
        if (response.status === 200) {
          setClientSecret(response?.data?.clientSecret);
          handleStipeModal(amount, paymentNumber);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const handlePaymentModal = paymentNumber => {
    const method = filterById(
      paymemtMethodOptions,
      watch(`method${paymentNumber}`)
    );

    if (method.name === paymentMethods.STRIPE && !authService?.getUser()) {
      openNewStripeModal(
        parseFloat(watch(`finalAmount${paymentNumber}`)),
        paymentNumber,
        false
      );
    } else {
      setValue('paymentOption', method._id);
      setPayment(prevState => {
        return {
          ...prevState,
          isOpen: true,
          amount: parseFloat(watch(`finalAmount${paymentNumber}`)),
          amountBsS: parseFloat(watch(`finalAmountBsS${paymentNumber}`)),
          methods: [method],
          paymentNumber: paymentNumber,
          selectedMembership: selectedMembership || '',
        };
      });
    }
  };

  const calculateIGTFTotal = () => {
    let totalIGTF = 0;

    for (let i = 0; i < watch('paymentMethodsQuantity'); i++) {
      const method = filterById(paymemtMethodOptions, watch(`method${i}`));
      if (method && !['BsS'].includes(method.currency)) {
        totalIGTF = totalIGTF + parseFloat(watch(`amount${i}`));
      }
      setValue('totalIGTF', ((totalIGTF * returnIGTF()) / 100)?.toFixed(2));
    }
  };

  const calculateIGTF = index => {
    const method = filterById(paymemtMethodOptions, watch(`method${index}`));
    // Calculate IGTF
    if (method && !['BsS'].includes(method.currency)) {
      setValue(
        `IGTF${index}`,
        (watch(`amount${index}`) * (returnIGTF() / 100)).toFixed(2)
      );
    } else {
      setValue(`IGTF${index}`, 0);
    }
    const finalAmount =
      parseFloat(watch(`amount${index}`)) + parseFloat(watch(`IGTF${index}`));
    setValue(`finalAmount${index}`, NaNtoNumber(finalAmount).toFixed(2));
    setValue(
      `finalAmountBsS${index}`,
      (NaNtoNumber(finalAmount) * dollarRate).toFixed(2)
    );
  };

  const handleMethodChange = index => {
    calculateIGTF(index);
    calculateIGTFTotal();
  };

  const validateIfCanPay = index => {
    const paymentMethodsQuantity = parseFloat(watch('paymentMethodsQuantity'));

    const billAmount = parseFloat(watch('billAmount'));
    const totalIGTF = parseFloat(watch('totalIGTF'));

    let accumulatedAmount = 0;
    let accumulatedIGTF = 0;
    for (let i = 0; i < paymentMethodsQuantity; i++) {
      accumulatedAmount = accumulatedAmount + parseFloat(watch(`amount${i}`));
      accumulatedIGTF = accumulatedIGTF + parseFloat(watch(`IGTF${i}`));

      if (!watch(`method${i}`)) {
        return false;
      }
    }

    if (
      accumulatedAmount !== billAmount ||
      parseFloat(accumulatedIGTF.toFixed(2)) !== totalIGTF
    ) {
      return false;
    }

    // First payment mus be executed before enabiling other buttons
    if (index !== 0 && !watch(`reference${0}`) && !fileUploaded[0]) {
      return false;
    } else return true;
  };

  const openPopupWindow = () => {
    setIsloading(true);
    const paramsToSend = {
      identification: watch('casheaUserIdentification'),
      invoiceId: selectedMembership?.membershipId.toString(),
      productId: selectedMembership?.membershipId.toString(),
      sku: selectedMembership?._id.toString(),
      price: watch('finalPrice'),
    };
    const encodedParams = encodeURIComponent(JSON.stringify(paramsToSend));
    const popupUrl = `/cashea-confirmation?params=${encodedParams}`; // O la URL de tu componente hijo

    const newWindow = window.open(
      popupUrl,
      '_blank',
      'width=800,height=600,scrollbars=yes'
    );
    setPopupWindow(newWindow);
  };

  useEffect(() => {
    let popupChecker;

    const handleStorage = event => {
      // Solo procesa si la clave es 'casheaResult' y hay datos nuevos
      if (event.key === 'casheaResult' && event.newValue) {
        const data = JSON.parse(event.newValue);
        setValue('casheaParentOrderId', data.casheaParentOrderId);
        setValue('casheaOrderId', data.casheaOrderId);
        setValue('casheaDownPayment', data.casheaDownPayment);
        setValue('billAmount', data.casheaDownPayment);
        setValue('amount0', data.casheaDownPayment);
        setValue(
          'amountBsS0',
          (data.casheaDownPayment * dollarRate).toFixed(2)
        );
        setValue('referenceCashea', data.casheaOrderId);
        setValue('initial', data.casheaDownPayment);
        setValue('finalAmount0', data.casheaDownPayment);
        setValue(
          'finalAmountBsS0',
          (data.casheaDownPayment * dollarRate).toFixed(2)
        );

        setValue(
          'financialAmount0',
          ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3).toFixed(
            2
          )
        );
        setValue(
          'financialAmount1',
          ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3).toFixed(
            2
          )
        );
        setValue(
          'financialAmount2',
          ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3).toFixed(
            2
          )
        );
        setValue(
          'financialAmountBsS0',
          (
            ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3) *
            dollarRate
          ).toFixed(2)
        );
        setValue(
          'financialAmountBsS1',
          (
            ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3) *
            dollarRate
          ).toFixed(2)
        );
        setValue(
          'financialAmountBsS2',
          (
            ((watch('finalPrice') - Number(data.casheaDownPayment)) / 3) *
            dollarRate
          ).toFixed(2)
        );

        setValue('casheaUserIdentification', '');
        setIsloading(false);
        localStorage.removeItem('casheaResult');
        if (popupChecker) clearInterval(popupChecker);
      }
    };

    window.addEventListener('storage', handleStorage);

    if (popupWindow) {
      popupChecker = setInterval(() => {
        if (popupWindow.closed) {
          setValue('casheaUserIdentification', '');
          setIsloading(false);
          clearInterval(popupChecker);
        }
      }, 1000);
    }

    return () => {
      window.removeEventListener('storage', handleStorage);
      if (popupWindow && !popupWindow.closed) {
        popupWindow.close();
      }
    };
  }, [popupWindow, dollarRate, setValue, watch]);

  useEffect(() => {
    if ([paymentTypeOption?.CASHEA].includes(watch('paymentType'))) {
      setValue('numCasheaDues', 3);
    }
  }, [watch('paymentType')]);

  let handleSubmit = () => { };
  const onSubmit = handleSubmit(async data => {
    // let dataToPost = { ...data };
    // delete dataToPost?.finalPrice;
    // delete dataToPost?.finalPriceInBsS;
    // delete dataToPost?.paymentOption;
    // delete dataToPost?.selectedMembership;
    // delete dataToPost?.numCasheaDues;
    // dataToPost.membership = membership?._id;
    // dataToPost = loadPaymentForms(dataToPost);
    // if (!dataToPost) {
    //   return null;
    // }
    // let fileToPost = appendFile(dataToPost);
    // if (!isLoading && fileToPost) {
    //   setIsloading(true);
    //   paymentsService
    //     .createMembershipPayment(fileToPost)
    //     .then((response) => {
    //       if ([200, 201].includes(response.status)) {
    //         updateMembershipStatus(membership?._id);
    //         // setIsloading(false);
    //       } else {
    //         setIsloading(false);
    //         notify(`${response.message}`, 'error');
    //       }
    //     })
    //     .catch((error) => {
    //       setIsloading(false);
    //       notify(`ERROR al realizar el pago`, 'error');
    //     });
    // }
  });

  const multiplePaymentsTable = {
    header: multiplePaymentsTableHeader,
    validation: { validateIfCanPay: validateIfCanPay },
    fileUploaded: fileUploaded,
    action: { handlePaymentModal: handlePaymentModal },
    onChange: {
      handleAmountChange: handleAmountChange,
      handleMethodChange: handleMethodChange,
      handleIGTFChange: handleIGTFChange,
    },
    dollarRate: dollarRate,
    options: { paymemtMethodOptions: paymemtMethodOptions },
    watch,
    register,
    handleSubmit,
    errors,
    label: true,
  };

  useEffect(() => {
    validatePaymentOptions();
  }, []);
  return (
    <>
      <StripeModal
        stripeModal={stripeModal}
        handleStipeModal={handleStipeModal}
        clientSecret={clientSecret}
        successfulStripe={successfulStripe}
        watch={watch}
      />

      <NewPaymentModal
        fileUploaded={fileUploaded}
        setFileUploaded={setFileUploaded}
        removeImage={removeImage}
        cancelPayment={cancelPayment}
        acceptPayment={acceptPayment}
        selectedMethod={selectedMethod}
        register={register}
        watch={watch}
        dollarRate={dollarRate}
        payment={payment}
        errors={errors}
        control={control}
        handleReferenceChange={handleReferenceChange}
        setValue={setValue}
      />

      <div className="row">
        <Input
          bootstrap={'col-12 col-md-6 '}
          label={'Plan a Renovar'}
          type={'select'}
          name={'code'}
          register={register}
          placeholder={''}
          options={options?.planOptions}
          errors={errors?.code?.message}
          disabled={true}
        />
        <Input
          bootstrap={'col-12 col-md-6 '}
          label={'RCV'}
          type={'select'}
          name={'rcv'}
          register={register}
          placeholder={''}
          options={options?.rcvOptions}
          errors={errors?.rcv?.message}
          disabled={true}
        />
        <Input
          bootstrap={'col-12 col-md-6 '}
          label={'Precio USD'}
          type={'text'}
          name={'finalPrice'}
          register={register}
          placeholder={''}
          errors={errors?.finalPrice?.message}
          disabled={true}
        />
        <Input
          bootstrap={'col-12 col-md-6 '}
          label={'Precio BsS'}
          type={'text'}
          name={'finalPriceInBsS'}
          register={register}
          placeholder={''}
          errors={errors?.finalPriceInBsS?.message}
          disabled={true}
        />
        <Input
          bootstrap={'col-12 col-md-6 '}
          label={'Tipo de pago *'}
          type={'select'}
          name={'paymentType'}
          register={register}
          placeholder={''}
          options={paymentTypeVar}
          errors={errors?.paymentType?.message}
          onChange={setPaymentType}
          disabled={watch('reference1')}
        // disabled={true}
        />
        {![paymentTypeOption?.COURTESY, paymentTypeOption?.PENDING].includes(
          watch('paymentType')
        ) &&
          parseFloat(watch('finalPrice')) !== 0 && (
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Cantidad de Metodos de pagos *'}
              type={'select'}
              name={'paymentMethodsQuantity'}
              register={register}
              options={paymentMethodsLimit}
              placeholder={''}
              onChange={selectUniquePayment}
              errors={errors?.paymentMethodsQuantity?.message}
              disabled={
                watch('reference0') ||
                fileUploaded[0] ||
                [paymentTypeOption?.CASHEA].includes(watch('paymentType'))
              }
            />
          )}

        <div
          className="buttons-center-container"
          style={{ margin: '24px 0px 48px 0px' }}
        >
          {[paymentTypeOption?.CASHEA].includes(watch('paymentType')) &&
            !watch('casheaParentOrderId') &&
            watch('paymentMethodsQuantity') && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Input
                  type={'text'}
                  style={{
                    border: '2px solid #ffa825',
                  }}
                  bootstrap={'col-12 col-md-3'}
                  label={'Cédula de cliente Cashea'}
                  name={'casheaUserIdentification'}
                  register={register}
                  placeholder={''}
                  errors={errors?.casheaUserIdentification?.message}
                />

                <ActionButton
                  label={'Continuar con Cashea'}
                  action={() => openPopupWindow()}
                  disabled={!watch('casheaUserIdentification')}
                />
              </div>
            )}
        </div>

        <MultiplePaymentsTable table={multiplePaymentsTable} />
        <NextQuotasTable table={nextQuotaTable} />

        <CashBackComponent
          register={register}
          errors={errors}
          watch={watch}
        // options={{
        //   paymemtMethodOptions: paymemtMethodOptions,
        //   filteredMethods: filteredMethods,
        // }}
        // onChange={{
        //   handleCashbackBs: handleCashbackBs,
        //   handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
        // }}
        // handleDrop={handleDrop}
        // cashBackImage={cashBackImage}
        // removeFile={removeFile}
        // errorsDropzone={errorsDropzone}
        />
      </div>
      <div
        className="buttons-center-container"
        style={{ margin: '0px 0px 48px 0px' }}
      >
        <AltButton label={'Cancelar Renovacion'} action={cancelRenovation} />
        {/* <ActionButton label={'Continuar'} action={selfRenew} /> */}
        {validateButtonName()}
      </div>
    </>
  );
};
